module.exports = __webpack_public_path__ + "img/icon-white-44.4630911d.svg";